import { render, staticRenderFns } from "./dialogs.vue?vue&type=template&id=0ead87ef&scoped=true"
import script from "./dialogs.vue?vue&type=script&lang=js"
export * from "./dialogs.vue?vue&type=script&lang=js"
import style0 from "./dialogs.vue?vue&type=style&index=0&id=0ead87ef&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ead87ef",
  null
  
)

export default component.exports